<ng-container wp-isolated-query-space>
  <op-filters-tab-inner #tabInner></op-filters-tab-inner>
</ng-container>
